import { createCustomInterceptorInstance } from "@fundacao/shared-components/esm/ie/renovacao";
import axios, {AxiosInstance} from "axios";
import { TipoProduto } from "../../models/tipo-produto";

class TipoProdutoService {
  private instance: AxiosInstance;

  constructor() {
    this.instance = createCustomInterceptorInstance(process.env.REACT_APP_LEGADO_API);
  }

  async getTipoProduto(): Promise<TipoProduto[]>{
    const resp  = await this.instance
      .get(`/tipo-produto`)
      .catch(err => Promise.reject(err.response));
    return resp.data.produtos;
  }
}

export default new TipoProdutoService();